var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aims" }, [
    _c("h3", { staticClass: "mb-4" }, [_vm._v(_vm._s(_vm.module.title))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ml-4" },
      [
        _c(
          "Accordion",
          _vm._l(_vm.module.module_sections, function(moduleSection) {
            return _c(
              "AccordionItem",
              { key: moduleSection.id },
              [
                _c("template", { slot: "accordion-trigger" }, [
                  _c("strong", [_vm._v(_vm._s(moduleSection.title))])
                ]),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "accordion-content" },
                  _vm._l(moduleSection.module_questions, function(
                    moduleQuestion,
                    i
                  ) {
                    return _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(moduleQuestion.question_text)
                          }
                        }),
                        _vm._v(" "),
                        moduleQuestion.question_picture
                          ? _c("img", {
                              attrs: {
                                src: "/img/" + moduleQuestion.question_picture,
                                alt: "Question picture"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(moduleQuestion.module_answers, function(answer) {
                          return [
                            _c("input", {
                              attrs: {
                                disabled: true,
                                type: "radio",
                                id: "module-question-answer-" + answer.id
                              },
                              domProps: {
                                checked: _vm.isModuleAnswerChecked(answer.id)
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "module-question-answer-" + answer.id
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(answer.value) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]
                        }),
                        _vm._v(" "),
                        i < moduleSection.module_questions.length - 1
                          ? _c("hr")
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              ],
              2
            )
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", { staticClass: "mb-4" }, [_vm._v("Questionnaire")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ml-4" },
      [
        _c(
          "Accordion",
          _vm._l(_vm.traitStatementsByCluster, function(
            traitStatements,
            cluster
          ) {
            return _c(
              "AccordionItem",
              { key: cluster },
              [
                _c("template", { slot: "accordion-trigger" }, [
                  _c("strong", [
                    _vm._v(
                      "Question set " +
                        _vm._s(cluster + 1) +
                        " of " +
                        _vm._s(_vm.traitStatementsByCluster.length)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "accordion-content" },
                  _vm._l(traitStatements, function(traitStatement) {
                    return _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("p", {
                          domProps: { innerHTML: _vm._s(traitStatement.text) }
                        }),
                        _vm._v(" "),
                        _vm._l(
                          traitStatement.rating_maximum -
                            traitStatement.rating_minimum,
                          function(rating) {
                            return [
                              _c("input", {
                                attrs: {
                                  disabled: true,
                                  type: "radio",
                                  id:
                                    "trait-statement-" +
                                    traitStatement.id +
                                    "-" +
                                    rating
                                },
                                domProps: {
                                  checked: _vm.isTraitRatingSelected(
                                    traitStatement.id,
                                    rating + traitStatement.rating_minimum
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for:
                                      "trait-statement-" +
                                      traitStatement.id +
                                      "-" +
                                      rating
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        rating + traitStatement.rating_minimum
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          }
                        ),
                        _vm._v(" "),
                        _c("hr")
                      ],
                      2
                    )
                  }),
                  0
                )
              ],
              2
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51cf400b", { render: render, staticRenderFns: staticRenderFns })
  }
}